var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1144 100.153C88.9427 100.153 100.153 88.9427 100.153 75.1144C100.153 61.2861 88.9427 50.076 75.1144 50.076C61.2862 50.076 50.0761 61.2861 50.0761 75.1144C50.0761 88.9427 61.2862 100.153 75.1144 100.153Z",
    stroke: "#D95722",
    strokeWidth: 12.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1144 12.5186V25.0377M75.1144 125.191V137.71M30.8592 30.8591L39.6852 39.6851M110.544 110.544L119.37 119.37M12.5186 75.1144H25.0378M125.191 75.1144H137.71M30.8592 119.37L39.6852 110.544M110.544 39.6851L119.37 30.8591",
    stroke: "#D95722",
    strokeWidth: 12.5192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighTemperature);
export default __webpack_public_path__ + "static/media/high-temperature.cad375d04e93ebd68be37771ae579548.svg";
export { ForwardRef as ReactComponent };